export default "__VITE_ASSET__DIk_ihky__"